const api = (() => {
  const {
    REACT_APP_PROTOCOL,
    REACT_APP_HOST,
    REACT_APP_PORT
  } = process.env;
  const BASE_URL = `${REACT_APP_PROTOCOL}://${REACT_APP_HOST}:${REACT_APP_PORT}`;

  function putAccessToken(token) {
    localStorage.setItem('accessToken', token);
  }

  function getAccessToken() {
    return localStorage.getItem('accessToken');
  }

  function putRefreshToken(token) {
    return localStorage.setItem('refreshToken', token);
  }

  function getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }

  function deleteToken() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  }

  async function _fetchWithAuth(url, options = {}) {
    return fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${getAccessToken()}`,
      },
    });
  }

  async function register({ fullname, email, password }) {
    const response = await fetch(`${BASE_URL}/clp/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fullname,
        email,
        password,
      }),
    });

    const responseJson = await response.json();
    return responseJson;
  }

  async function forgetPassword({ payload }) {
    const response = await fetch(`${BASE_URL}/users/forget-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const responseJson = await response.json();
    return responseJson;
  }

  async function login({ email, password }) {
    const response = await fetch(`${BASE_URL}/authentications`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    const responseJson = await response.json();
    const { status, message, data } = responseJson;

    // if (status !== 'success') {
    //   throw new Error(message);
    // }

    return { status, message, data };
    // return data;
  }

  async function loginAsEmpBcf({ email, password }) {
    const response = await fetch(`${BASE_URL}/authentications-bcf`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    const responseJson = await response.json();
    const { status, message, data } = responseJson;

    return { status, message, data };
  }

  async function loginAsMentors({ email, password }) {
    const response = await fetch(`${BASE_URL}/authentications/clp/mentors`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    const responseJson = await response.json();
    const { status, message, data } = responseJson;

    return { status, message, data };
  }

  async function getOwnProfile() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/users/me`);
    const responseJson = await response.json();

    return responseJson;
  }

  async function getOwnFullProfile({ batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/users/me/detail?batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getOwnOfferedProgram() {
    const response = await _fetchWithAuth(`${BASE_URL}/program/offered-program/users`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getOwnBCFProfile() {
    const response = await _fetchWithAuth(`${BASE_URL}/bcf/users/me`);
    const responseJson = await response.json();

    const { status, message, error, data } = responseJson;

    return { status, error, message, data };
  }

  async function refreshToken() {
    const response = await _fetchWithAuth(`${BASE_URL}/authentications`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        refreshToken: `${getRefreshToken()}`,
      }),
    });

    const responseJson = await response.json();
    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }
    putAccessToken(data.accessToken);
  }

  async function getCheckUsersByNim({ nim }) {
    const response = await fetch(`${BASE_URL}/clp/users/${nim}/update`);

    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      return { status, message, data: null }
    }

    return { status, message: null, data };
  }

  async function getProfileByNim({ nim }) {
    const response = await fetch(`${BASE_URL}/clp/users/${nim}/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      return { status, message, data: null }
    }

    return { status, message: null, data };
  }

  // CLP Updated Profile
  async function updateProfile({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/users`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...payload
      }),
    });

    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      return { status, message, data: null }
    }

    return { status, message: null, data };
  }

  // async function getProvinces() {
  //   const response = await fetch(`https://www.emsifa.com/api-wilayah-indonesia/api/provinces.json`);

  //   const responseJson = await response.json();

  //   // const { status, message, data } = responseJson;

  //   // if (status !== 'success') {
  //   //   throw new Error(message);
  //   // }

  //   return responseJson;
  // }

  // async function getKabKotaByIdPronvice(id) {
  //   const response = await fetch(`https://www.emsifa.com/api-wilayah-indonesia/api/regencies/${id}.json`);

  //   const responseJson = await response.json();

  //   // const { status, message, data } = responseJson;

  //   // if (status !== 'success') {
  //   //   throw new Error(message);
  //   // }

  //   return responseJson;
  // }

  // DOMICILE
  async function getProvincies() {
    const response = await fetch(`${BASE_URL}/domicile/provincies`);

    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getRegenciesByProvincies({ id }) {
    const response = await fetch(`${BASE_URL}/domicile/regencies/provincies/${id}`);

    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }
  // DOMICILE

  // Publication Feature

  async function searchPublications({ q, pageSize, page }) {
    const response = await fetch(`${BASE_URL}/clp/publications?q=${q}&pageSize=${pageSize}&page=${page}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getPublicationsBySlug({ slug }) {
    const response = await fetch(`${BASE_URL}/clp/publications/${slug}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getListProvinceInstitution() {
    const response = await fetch(`${BASE_URL}/clp/publications/institution/province`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  // App (LoggedIn)

  async function addPublications({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/publications`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function deletePublications({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/publications/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function updatePublications({ id, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/publications/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function getPublicationsApp({ pageSize, page }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/app/publications?pageSize=${pageSize}&page=${page}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getPublicationsById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/app/publications/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getPublicationsForUpdateById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/publications/${id}/update`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getTopics() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/topics`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function updatePublicationsIsDraft({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/publications/${id}/draft`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  // Evaluation (PAT)
  async function appGetFriendsDivisiPAT({ batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-pat/evaluated/users?batchId=${batchId}`);
    const responseJson = await response.json();
    return responseJson;
  }

  async function appPostEvaluatePAT({ id, batchId, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-pat/evaluated/users/${id}?batchId=${batchId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();
    return responseJson;
  }

  async function appGetClassificationsPAT() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/classifications-pat`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function appGetFinalEvaluations({ batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-final/users?batchId=${batchId}`);
    const responseJson = await response.json();
    return responseJson
  }

  // Admin (LoggedIn)
  async function getDashboardAdmin() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/dashboard`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getPublicationsAdmin({ publicationStatus, pageSize, page }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/publications?publicationStatus=${publicationStatus}&pageSize=${pageSize}&page=${page}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getStatusPublicationsAdmin() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/publications/status`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetPublicationsById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/publications/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminPostReviewsForPublications({ id, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/publications/${id}/reviews`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminPutReviewsForPublications({ publicationId, reviewId, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/publications/${publicationId}/reviews/${reviewId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminDeleteReviewsForPublications({ publicationId, reviewId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/publications/${publicationId}/reviews/${reviewId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminPutStatusHistoryForPublications({ publicationId, publicationHistoryId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/publications/${publicationId}/status/${publicationHistoryId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminGetAllUsers({ batchId, page, pageSize }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/users?batchId=${batchId}&pageSize=${pageSize}&page=${page}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetUsersById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/users/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminUsersExports({ kepulangan }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/exports/users?status=${kepulangan}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function mentorsGetAllInstitutions() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/institutions`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function mentorsGetInstitutionsById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/institutions/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function mentorsGetClassificationsHardskillByMentors() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/classifications/hardskill`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }
  // MENTORS
  async function adminAddMentors({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();
    return responseJson;
  }

  async function adminDeleteMentorsById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminGetMentors({ batchId, pageSize, page }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors?batchId=${batchId}&pageSize=${pageSize}&page=${page}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetMentorsById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGeneratedStudents({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/${id}/generated-students`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseJson = await response.json();
    return responseJson;
  }

  async function adminAddClassifications({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/classifications-final/hard-skill`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();
    return responseJson;
  }

  async function adminUpdateClassifications({ divisionInstitutionsId, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/classifications-final/hard-skill/${divisionInstitutionsId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();
    return responseJson;
  }

  async function adminGetClassficationsHardskill({ pageSize, page, filterBy = '', batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/classifications-final/hard-skill?pageSize=${pageSize}&page=${page}&filterBy=${filterBy}&batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetClassficationsHardskillByDivisiLembagaId({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/classifications-final/hard-skill/division-institutions/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetClassficationsBCF() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/classifications/bcf`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminRefreshEvaluationsFinal({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations/${id}/refresh`);
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminGeneratedEvaluationsFinal({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations/${id}/generated`);
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminGetClassficationsBCFByUsersId({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-final/bcf/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetClassficationsSoftskill() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/classifications/softskill`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetAllEvaluates({ batchId, page, pageSize, filterBy = '' }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations?batchId=${batchId}&pageSize=${pageSize}&page=${page}&filterBy=${filterBy}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function mentorsGetAllEvaluates({ page, pageSize }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/evaluations?pageSize=${pageSize}&page=${page}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetEvaluatesById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      return { status, message, data: null }
    }

    return { status, message: null, data };
  }

  async function adminGetEvaluatesPATById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-pat/evaluated/${id}/friends`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetHasEvaluatedPATById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-pat/evaluated/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminDeleteHasEvaluatedPATById({ id, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-pat/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminGetInstitutions({ filterBy = '', batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/institutions?filterBy=${filterBy}&batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetInstitutionsDetailById({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/institutions/${id}/detail`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetProvinciesInstitutions({ batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/institutions-provincies?batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetInstitutionsById({ id, batchId, filterBy = '' }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/institutions/${id}?batchId=${batchId}&filterBy=${filterBy}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetDivisions() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/divisions`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminAddDivisionByInstitutions({ id, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/institutions/${id}/divisions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();
    return responseJson;
  }

  async function adminGetDivisionByInstitutions({ institutionsId, divisionInstitutionsId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/institutions/${institutionsId}/divisions/${divisionInstitutionsId}`);
    const responseJson = await response.json();
    return responseJson;
  }

  async function adminUpdateDivisionByInstitutions({ institutionsId, divisionInstitutionsId, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/institutions/${institutionsId}/divisions/${divisionInstitutionsId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();
    return responseJson;
  }

  async function adminGetDivisionByInstitutionsId({ id, batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/institutions/${id}/divisions?batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminDeleteHasEvaluatedFromMentors({ id, classificationsType }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-final/${id}/reset?classifications=${classificationsType}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  // NOT USED!
  async function adminAddEvaluate({ id, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/admin/evaluations/${id}/evaluates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminUpdateEvaluate({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-final/bcf`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminUpdateEvaluateNote({ finalEvaluationNote, id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-final/${id}/note`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        finalEvaluationNote,
      }),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminGeEvaluationsFinalHS({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-final/hard-skill/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function mentorsUpdateEvaluationsFinalHS({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-final/hard-skill`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function adminGeEvaluationsFinalSS({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-final/soft-skill/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function mentorsUpdateEvaluationsFinalSS({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations-final/soft-skill`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function mentorsAddEvaluateSoftskill({ id, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/evaluations/${id}/evaluates/softskill`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function mentorsAddEvaluateHardskill({ id, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/evaluations/${id}/evaluates/hardskill`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function mentorsAddEvaluate({ id, payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/mentors/evaluations/${id}/evaluates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return message;
  }

  async function mentorsDeleteStudentsEvaluate({ id, batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations/${id}/mentors?batchId=${batchId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseJson = await response.json();
    return responseJson;
  }

  async function mentorAssignStudentsEvaluate({ id, batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/evaluations/${id}/mentors?batchId=${batchId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseJson = await response.json();
    return responseJson;
  }

  async function getHasUpdatedStudent({ batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/users/has-update?batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getNewUsersRegistrations({ batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/users/new-users?batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getCountUsersRegistrationsByUniversities({ batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/users/users-universities?batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getTimelineByBatchId({ batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/dashboard/timeline?batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  // Registrations

  async function getRegistrations({ page, pageSize, batchId, divisionInstitutionsId, statusAcceptanceProgramId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/registrations?page=${page}&pageSize=${pageSize}&batchId=${batchId}&divisionInstitutionsId=${divisionInstitutionsId}&statusAcceptanceProgramId=${statusAcceptanceProgramId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getRegistrationsDetail({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/registrations/${id}`);
    const responseJson = await response.json();
    return responseJson;
  }

  async function addRegistrations({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/registrations`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const responseJson = await response.json();
    return responseJson;
  }

  async function getRegistrationsUsers() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/registrations/users`);
    const responseJson = await response.json();
    return responseJson;
  }

  async function mentorsUpdateStatusAcceptanceRegistrations({ payload, id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/registrations/${id}/acceptance`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return responseJson;
  }

  async function getStatusAcceptance() {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/registrations/status-acceptance`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getRegistrationsInstitutions({ batchId, regenciesId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/registrations/institutions?batchId=${batchId}&regenciesId=${regenciesId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function getRegistrationsInstitutionsDetail({ divisionInstitutionsId, batchId }) {
    const response = await _fetchWithAuth(`${BASE_URL}/clp/registrations/institutions/${divisionInstitutionsId}?batchId=${batchId}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetUniversities({ q = '', page, pageSize }) {
    const response = await fetch(`${BASE_URL}/universities?q=${q}&page=${page}&pageSize=${pageSize}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminGetUniversitiesDetail({ id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/universities/${id}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminAddUniversities({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/universities`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return responseJson;
  }

  async function adminUpdateUniversities({ payload, id }) {
    const response = await _fetchWithAuth(`${BASE_URL}/universities/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return responseJson;
  }

  async function adminGetMajorByUniversities({ id }) {
    const response = await fetch(`${BASE_URL}/universities/${id}/major`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  async function adminAddMajor({ payload }) {
    const response = await _fetchWithAuth(`${BASE_URL}/universities/major`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();

    const { status, message } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return responseJson;
  }

  async function adminGetMajor({ q = '', page, pageSize }) {
    const response = await _fetchWithAuth(`${BASE_URL}/universities/major?q=${q}&page=${page}&pageSize=${pageSize}`);
    const responseJson = await response.json();

    const { status, message, data } = responseJson;

    if (status !== 'success') {
      throw new Error(message);
    }

    return data;
  }

  return {
    putAccessToken,
    getAccessToken,
    putRefreshToken,
    getRefreshToken,
    refreshToken,
    deleteToken,
    register,
    forgetPassword,
    login,
    getOwnProfile,
    getOwnFullProfile,
    getOwnOfferedProgram,
    getOwnBCFProfile,
    getCheckUsersByNim,
    getProfileByNim,
    updateProfile,
    // DOMICILE
    getProvincies,
    getRegenciesByProvincies,
    // DOMICILE
    getPublicationsApp,
    searchPublications,
    getPublicationsBySlug,
    getListProvinceInstitution,
    getPublicationsById,
    deletePublications,
    addPublications,
    updatePublications,
    getPublicationsForUpdateById,
    getTopics,
    updatePublicationsIsDraft,
    // Users (PAT)
    appGetFriendsDivisiPAT,
    appPostEvaluatePAT,
    appGetClassificationsPAT,
    // Evalautions
    appGetFinalEvaluations,
    // Admin
    getDashboardAdmin,
    getPublicationsAdmin,
    getStatusPublicationsAdmin,
    adminGetPublicationsById,
    adminPostReviewsForPublications,
    adminPutReviewsForPublications,
    adminDeleteReviewsForPublications,
    adminPutStatusHistoryForPublications,
    adminGetAllUsers,
    adminGetUsersById,
    adminUsersExports,
    loginAsEmpBcf,
    loginAsMentors,
    // Evaluate
    // Admin Mentors
    adminAddMentors,
    adminDeleteMentorsById,
    adminGetMentors,
    adminGetMentorsById,
    adminGeneratedStudents,
    adminAddClassifications,
    adminUpdateClassifications,
    adminGetClassficationsHardskill,
    adminGetClassficationsHardskillByDivisiLembagaId,
    adminGetClassficationsBCF,
    adminGetClassficationsBCFByUsersId,
    adminGetClassficationsSoftskill,
    adminGetAllEvaluates,
    mentorsGetAllEvaluates,
    adminGetInstitutions,
    adminGetInstitutionsDetailById,
    adminGetProvinciesInstitutions,
    adminGetInstitutionsById,
    adminGetDivisions,
    adminAddDivisionByInstitutions,
    adminGetDivisionByInstitutions,
    adminUpdateDivisionByInstitutions,
    adminGetDivisionByInstitutionsId,
    adminGetEvaluatesById,
    adminGetEvaluatesPATById,
    adminGetHasEvaluatedPATById,
    adminDeleteHasEvaluatedPATById,
    adminAddEvaluate,
    adminUpdateEvaluate,
    adminUpdateEvaluateNote,
    adminDeleteHasEvaluatedFromMentors,
    adminRefreshEvaluationsFinal,
    adminGeneratedEvaluationsFinal,
    mentorsAddEvaluateSoftskill,
    mentorsAddEvaluateHardskill,
    mentorsAddEvaluate,
    mentorsGetAllInstitutions,
    mentorsGetInstitutionsById,
    mentorsGetClassificationsHardskillByMentors,
    adminGeEvaluationsFinalHS,
    adminGeEvaluationsFinalSS,
    mentorsUpdateEvaluationsFinalHS,
    mentorsUpdateEvaluationsFinalSS,
    mentorsDeleteStudentsEvaluate,
    mentorAssignStudentsEvaluate,
    // DASHBOARD
    getHasUpdatedStudent,
    getNewUsersRegistrations,
    getCountUsersRegistrationsByUniversities,
    getTimelineByBatchId,
    // REGISTRATIONS
    getRegistrations,
    getRegistrationsDetail,
    addRegistrations,
    getRegistrationsUsers,
    mentorsUpdateStatusAcceptanceRegistrations,
    getStatusAcceptance,
    getRegistrationsInstitutions,
    getRegistrationsInstitutionsDetail,
    // UNIVERSITIES
    adminAddUniversities,
    adminUpdateUniversities,
    adminGetUniversities,
    adminGetUniversitiesDetail,
    adminGetMajorByUniversities,
    adminAddMajor,
    adminGetMajor,
  }
})();

export default api;
